import { render, staticRenderFns } from "./comment-preview.vue?vue&type=template&id=e517f9f6&"
import script from "./comment-preview.vue?vue&type=script&lang=js&"
export * from "./comment-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports